// extracted by mini-css-extract-plugin
export default {"formMultiSelect":"FormMultiSelect_formMultiSelect__79ZrF","chipContainer":"FormMultiSelect_chipContainer__1-L7Z"};